import { useSettings } from '@backpackjs/storefront';

import { Image } from 'theme-ui';
import { Link } from '@snippets';

export function SocialLinks({ size = 32, shareLink, ...props }) {
  const settings = useSettings();
  const socialLinks = (settings?.social?.links || []).filter(
    ({ network }) => network === 'facebook' || network === 'instagram'
  );

  const socials = [
    {
      network: 'instagram',
      url: 'https://www.instagram.com/?url=',
    },
    {
      network: 'facebook',
      url: 'https://www.facebook.com/sharer/sharer.php?u=',
    },
  ];

  return shareLink && socialLinks?.length ? (
    <div data-comp={SocialLinks.displayName} {...props} className="flex gap-3">
      {socials.map(({ network, url }, index) => {
        return (
          <Link
            key={index}
            newTab
            href={url ? `${url}${encodeURIComponent(shareLink)}` : ''}
            aria-label={network}
            sx={{
              width: size,
              height: size,
            }}
          >
            <Image
              src={`/icons/icon-${network}-share.png`}
              alt={network}
              sx={{}}
            />
          </Link>
        );
      })}
    </div>
  ) : null;
}

SocialLinks.displayName = 'SocialLinks';
